import { baseApi } from './BaseService';
import {
  GetTagsTranslationsResponse,
  GetTagTranslationByIdResponse,
  UpdateTagTranslationByIdRequest,
} from '../responseTypes/tagsTranslations';


const baseUrl = '/filer/admin/translations';

export const tagTranslationsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    getTranslations: build.query<
      GetTagsTranslationsResponse, {}
    >({
      query: () => ({
        url: `${baseUrl}`,
      }),
    }),
    getTranslationById: build.query<GetTagTranslationByIdResponse, { translationId: string }>({
      query: ({ translationId }) => ({
        url: `${baseUrl}/${translationId}`,
      }),
      providesTags: ['TagTranslation'],
    }),
    createTranslation: build.mutation<GetTagTranslationByIdResponse, UpdateTagTranslationByIdRequest>({
      query: (data) => ({
        url: `${baseUrl}`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['TagTranslation'],
    }),
    updateTranslationById: build.mutation<
      GetTagTranslationByIdResponse,
      { translationId: string; data: UpdateTagTranslationByIdRequest }
    >({
      query: ({ translationId, data }) => ({
        url: `${baseUrl}/${translationId}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['TagTranslation'],
    }),
    deleteTranslationById: build.mutation<string, string>({
      query: (translationId) => ({
        url: `${baseUrl}/${translationId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['TagTranslation'],
    }),
  }),
});
